export default function ContactEntry() {
  return (
    <section id="contact" className="section-py bg-background-50">
      <div className="section-container">
        <div className="max-w-2xl mx-auto text-center">
          <div className="flex items-center justify-center gap-3 mb-8">
            <div className="w-1 h-6 rounded-full bg-primary-500"></div>
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
              投稿爆料
            </h2>
          </div>

          <div className="bg-background-100 rounded-xl border border-background-200/70 p-8 md:p-10">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 mx-auto mb-5">
              <i className="ri-mail-send-line text-2xl"></i>
            </div>

            <h3 className="text-lg font-bold font-heading text-foreground-900 mb-3">
              你有猛料？我们等你来爆！
            </h3>
            <p className="text-sm text-foreground-600 mb-6 leading-relaxed">
              无论你是赛事内部人士、知情观众还是热爱吃瓜的网友，只要你有真实可靠的大赛爆料线索，欢迎通过以下方式联系我们。51爆料网承诺严格保护爆料人隐私，让你的声音被更多人听到。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <div className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-50 text-accent-600">
                  <i className="ri-mail-line"></i>
                </div>
                <span>tips@51baoliao.com</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <div className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-50 text-accent-600">
                  <i className="ri-wechat-line"></i>
                </div>
                <span>51爆料小助手</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <div className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-50 text-accent-600">
                  <i className="ri-shield-check-line"></i>
                </div>
                <span>严格保护隐私</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}